import React from 'react';
import File_Icon from '../imageSrc/wenjianjia.png';
import File_Icon_HighLight from '../imageSrc/file_icon.png';
import File_Doc from '../imageSrc/fileDocument.png'
import More_Icon from '../imageSrc/file_option_more.png'
import './fileItem.css'
import {Popover,Modal} from 'antd'
import '../utils/commonFunc';
import {getSubStringWithDot} from "../utils/commonFunc";

class FileItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filePath:'12345',
            modalVisible:false,    //文件夹输入文件名的弹窗
            popoverVisible:false,  //操作弹窗
            optionVisible:'none',   //鼠标悬停展示操作按钮
        }
    }

    ////鼠标悬停展示功能按钮
    handleMouseOver = () => {
        this.setState({
            optionVisible:'inline',
        })
    };

    ////鼠标移走隐藏功能按钮
    handleMouseLeave = () => {
        this.setState({
            optionVisible:'none',
            popoverVisible:false,
        })
    };


    ////展示文件样式图片
    getFileIconWithType = (type) => {
        if (type === 1) {
            return File_Doc;
        } else {
            return File_Icon_HighLight;
        }
    };

    ////点击对应的cell
    handleItemClick = () => {
        //之后的filepath应该是从上级页面传过来的 this.props.filePath
        this.props.handleItemClick(this.props.fileName,this.props.dirId,this.props.type);
    };

    ////重命名窗口弹出
    handldRenaminClick = ()=> {
        this.setState({
            popoverVisible:false,
        });
        this.props.handleRename(this.props.dirId);
    };

    ////删除文件
    handleDeleteClick = () => {
        this.setState({
            popoverVisible:false,
        });
        this.props.handleDelete(this.props.dirId);
    };

    ////展示文件操作窗口
    handleShowPopover = ()=> {
        this.setState({
            popoverVisible:true,
        });
    };

    handleVisibleChange = popoverVisible => {
        this.setState({ popoverVisible });
    };

    getTitleString = (fileName) => {

        // let style =  {
        //     fontSize : 12 + 'px',
        //     fontFamily : 'SimSun'
        // }
        //
        // let span = document.createElement("span")
        // span.style.font = `${style.fontSize} ${style.fontFamily}`
        // span.innerHTML = fileName;
        // document.body.appendChild(span);
        // let rect = span.getBoundingClientRect();
        // let width = rect.width;
        // let height = rect.height;
        // document.body.removeChild(span);
        //
        //
        //
        // // console.log(width / 12,height,document.body.clientWidth * 0.15)
        return getSubStringWithDot(document.body.clientWidth * 0.15 / 12 - 3,fileName);
    };

    render() {
        const content = (
            <div>
                <h6 onClick={this.handldRenaminClick}>重命名</h6>
                <h6 onClick={this.handleDeleteClick}>删除</h6>
            </div>
        );
        return (
            <li className='item_style'>
                <div onMouseOver={this.handleMouseOver} onMouseLeave={this.handleMouseLeave}>
                    <div onClick={this.handleItemClick} style={{ width:95 + '%',display:'inline-block'}}>
                        <img className='img_style1' src={this.getFileIconWithType(this.props.type)}/>
                        <h1 className='file_name_break_style'>{this.getTitleString(this.props.fileName)}</h1>
                        <h2 className='file_modify_time'>{this.props.modifyTime}</h2>
                    </div>
                    <Popover onVisibleChange={this.handleVisibleChange}
                             visible={this.state.popoverVisible}
                             placement="bottom"
                             content={content}
                             trigger="click">
                        <img  onClick={this.handleShowPopover}
                              className='img_function'
                              src={More_Icon}
                              style={{display:this.state.optionVisible}}/>
                    </Popover>
                </div>
            </li>

        );
    }
}

export default FileItem